import { Tables } from '../../../../../../modules/API/Tables/Tables'
import { ITableDataProvider } from '../../../../../../generic/universal-table/types/data-provider.types'
import { growerTableAdapter } from '../adapters/growerTable.adapter'
import {
  GrowerCreatePayload,
  GrowerUiRow,
  GrowerUpdatePayload,
} from '../types/growerTable.types'

export const growerTableService: ITableDataProvider<
  GrowerUiRow,
  GrowerCreatePayload,
  GrowerUpdatePayload
> = {
  getList: async (): Promise<GrowerUiRow[]> => {
    const rows = await Tables.getGrowerList()
    return rows.map(growerTableAdapter.fromApi)
  },

  create: async (payload: GrowerCreatePayload): Promise<GrowerUiRow> => {
    const created = await Tables.createGrower(payload)
    return growerTableAdapter.fromApi(created)
  },

  update: async (
    id: number | string,
    payload: GrowerUpdatePayload
  ): Promise<GrowerUiRow> => {
    const updated = await Tables.updateGrower(Number(id), payload)
    return growerTableAdapter.fromApi(updated)
  },

  remove: async (id: number | string): Promise<void> => {
    await Tables.deleteGrower(Number(id))
  },
}
